import {
  EtaSource,
  useGetBookingAllAddressesEtaQuery,
  useGetAllAddressesEtaByTrackingHashQuery,
} from 'generated/graphql'

export interface AddressEta {
  bookingAddressId: string
  nextAddressETA: string | null
  etaWindowMinutes: number | null
  etaSource?: EtaSource | null
  etaLastUpdatedAt?: string | null
}

export const useAllAddressesEta = (bookingId: string | null, pollInterval = 60000) => {
  const { data, loading } = useGetBookingAllAddressesEtaQuery({
    fetchPolicy: 'cache-and-network',
    variables: { bookingId: Number(bookingId) },
    skip: !bookingId,
    pollInterval,
  })

  return {
    addressEtas:
      data?.bookingAllAddressesEta.map(
        ({ bookingAddressId, nextAddressETA, etaWindowMinutes, etaSource, etaLastUpdatedAt }) => ({
          bookingAddressId,
          nextAddressETA: nextAddressETA ?? null,
          etaWindowMinutes: etaWindowMinutes ?? null,
          etaSource,
          etaLastUpdatedAt: etaLastUpdatedAt ?? null,
        }),
      ) ?? [],
    etasLoading: loading,
  }
}

export const useAllAddressesEtaByTrackingHash = (trackingHash: string, pollInterval = 300000) => {
  const { data, loading } = useGetAllAddressesEtaByTrackingHashQuery({
    fetchPolicy: 'cache-and-network',
    variables: { hash: trackingHash },
    skip: !trackingHash,
    pollInterval,
  })

  return {
    addressEtas:
      data?.allAddressesEtaByTrackingHash.map(
        ({ bookingAddressId, nextAddressETA, etaWindowMinutes }) => ({
          bookingAddressId,
          nextAddressETA: nextAddressETA ?? null,
          etaWindowMinutes: etaWindowMinutes ?? null,
        }),
      ) ?? [],
    etasLoading: loading,
  }
}
